import React from "react";
import { Entry } from "contentful";
import { BrandInvestWhyInvest } from "@tiicker/util/lib/contentful/types";
import Markdown from "components/Markdown/Markdown";
import styles from "./WhyInvest.module.scss";

type Props = {
  whyInvest: Entry<BrandInvestWhyInvest>;
};

const WhyInvest: React.FC<Props> = ({ whyInvest }) => {
  if (!whyInvest) return null;

  return (
    <div className={styles.WhyInvest}>
      <h2
        className={styles.WhyInvest__header}
        style={{ color: whyInvest.fields.headerHex }}
      >
        {whyInvest.fields.header}
      </h2>
      <div className={styles.WhyInvest__columns}>
        <div className={styles.WhyInvest__column}>
          <img
            src={whyInvest.fields.columnOneImage.fields.file.url}
            alt={whyInvest.fields.columnOneImage.fields.title}
            className={styles.WhyInvest__columnImage}
          />
          <h4
            className={styles.WhyInvest__columnNeader}
            style={{ color: whyInvest.fields.headerHex }}
          >
            {whyInvest.fields.columnOneHeader}
          </h4>
          <Markdown
            markdownText={whyInvest.fields.columnOneDescription}
            className={styles.WhyInvest__description}
          />
        </div>
        <div className={styles.WhyInvest__column}>
          <img
            src={whyInvest.fields.columnTwoImage.fields.file.url}
            alt={whyInvest.fields.columnTwoImage.fields.title}
            className={styles.WhyInvest__columnImage}
          />
          <h4
            className={styles.WhyInvest__columnNeader}
            style={{ color: whyInvest.fields.headerHex }}
          >
            {whyInvest.fields.columnTwoHeader}
          </h4>
          <Markdown
            markdownText={whyInvest.fields.columnTwoDescription}
            className={styles.WhyInvest__description}
          />
        </div>
      </div>
    </div>
  );
};

export default WhyInvest;
